import { restRequest } from '../rest/rest';
export class SessionService {
    constructor(config) {
        this.sessionsEndpoint = '/digital/v3/chat/api/user/sessions';
        this.transcriptEndpoint = '/digital/v3/chat/api/user/transcript';
        this.config_ = config;
    }
    async getSessions(token) {
        try {
            const sessions = (await restRequest(`${this.config_.environment}${this.sessionsEndpoint}`, 'GET', undefined, token));
            return sessions;
        }
        catch (e) {
            const chatError = e;
            if (chatError && chatError.code) {
                throw chatError;
            }
            else {
                throw { code: 'METHOD_ERROR', message: "Invalid response." };
            }
        }
    }
    async getTranscript(token, sessionId = '') {
        if (sessionId.length < 1) {
            throw { code: 'METHOD_ERROR', message: "Invalid session id." };
        }
        try {
            const transcript = (await restRequest(`${this.config_.environment}${this.transcriptEndpoint}/${sessionId}`, 'GET', undefined, token));
            return transcript;
        }
        catch (e) {
            const chatError = e;
            if (chatError && chatError.code) {
                throw chatError;
            }
            else {
                throw { code: 'METHOD_ERROR', message: "Invalid response." };
            }
        }
    }
}
//# sourceMappingURL=session-service.js.map